import { Select } from '@radix-ui/themes';
import { useGetWebhooksQuery } from '../../graphql/queries/GetWebhooks.generated';

interface WebhookSelectProps {
  webhookId?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const WebhookSelect = ({
  webhookId,
  onValueChange,
  disabled,
}: WebhookSelectProps) => {
  const { data, loading, error } = useGetWebhooksQuery();

  if (loading) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger placeholder="Loading" style={{ width: '100%' }} />
      </Select.Root>
    );
  }

  if (error || !data) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Error loading webhooks"
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  const webhooks = data.webhooks.edges
    .map(({ node }) => node)
    .filter((webhook) => webhook.url.includes('discord.com')); // Filter for Discord webhooks

  return (
    <Select.Root
      value={webhookId}
      onValueChange={onValueChange}
      disabled={disabled}
    >
      <Select.Trigger
        placeholder={
          webhooks.length === 0
            ? 'No Discord webhooks found'
            : 'Select a Discord webhook'
        }
        style={{ width: '100%' }}
      />
      <Select.Content>
        {webhooks.map(({ id, url, method, label }) => (
          <Select.Item key={id} value={id}>
            {label || `${method} - ${url}`}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default WebhookSelect;
